import React from 'react';
import PropTypes from 'prop-types';
import { FiSearch } from 'react-icons/fi';

function SearchInput(props) {
  const { messagesMapping, setMessageList, setSearchValue, classAttr } = props;

  const handleOnChange = (value) => {
    if (!value) {
      setMessageList(messagesMapping());
    } else {
      setMessageList((prev) =>
        prev.filter((msg) => `${msg.templateLabel} ${msg.content}`.toLowerCase().includes(value.toLowerCase())),
      );
    }
  };

  return (
    <div
      className="flex items-center space-x-2 w-full justify-self-end col-start-2"
      style={{ minWidth: '100px', maxWidth: '350px' }}
    >
      <FiSearch />
      <input
        className={`border-b border-zinc-300 bg-transparent outline-none w-full ${classAttr}`}
        type="text"
        name="search"
        placeholder="Rechercher..."
        onChange={(e) => {
          handleOnChange(e.target.value);
          setSearchValue(e.target.value);
        }}
      />
    </div>
  );
}

SearchInput.propTypes = {
  messagesMapping: PropTypes.func,
  setMessageList: PropTypes.func,
  setSearchValue: PropTypes.func,
  classAttr: PropTypes.string 
};
SearchInput.defaultProps = {
  messagesMapping: () => {},
  setMessageList: () => {},
  setSearchValue: () => {},
  classAttr: ''
};

export default SearchInput;
